import { apiClient } from './api'
import type { ApiResponse } from '@/types/api'

export type KTPStatus = 'not_submitted' | 'pending' | 'verified' | 'rejected'

export interface KTPStatusResponse {
  status: KTPStatus
  submittedAt?: string
  verifiedAt?: string
  rejectedCount: number
  rejectionReason?: string
}

export interface KTPAdminItem {
  userId: string
  email: string
  name: string
  gender?: 'L' | 'P'
  birthDate?: string
  ktpNik?: string
  ktpBirthDate?: string
  status: KTPStatus
  submittedAt?: string
  rejectedCount: number
  rejectionReason?: string
  signedImageUrl?: string
}

export const ktpService = {
  /** Submit a KTP image + identity details (multipart/form-data). */
  async submit(
    nik: string,
    birthDate: string,
    file: File,
  ): Promise<ApiResponse<KTPStatusResponse>> {
    const form = new FormData()
    form.append('ktp_nik', nik)
    form.append('birth_date', birthDate)
    form.append('file', file)
    return apiClient.post('/me/ktp', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  getStatus: async (): Promise<ApiResponse<KTPStatusResponse>> =>
    apiClient.get('/me/ktp'),

  withdraw: async (): Promise<ApiResponse<void>> =>
    apiClient.delete('/me/ktp'),

  listPending: async (
    limit = 20,
    offset = 0,
  ): Promise<ApiResponse<KTPAdminItem[]>> =>
    apiClient.get('/admin/ktp/pending', { params: { limit, offset } }),

  getDetail: async (userId: string): Promise<ApiResponse<KTPAdminItem>> =>
    apiClient.get(`/admin/ktp/${userId}?reveal=true`),

  verify: async (userId: string): Promise<ApiResponse<{ message: string }>> =>
    apiClient.post(`/admin/ktp/${userId}/verify`),

  reject: async (
    userId: string,
    reason: string,
  ): Promise<ApiResponse<{ message: string }>> =>
    apiClient.post(`/admin/ktp/${userId}/reject`, { reason }),
}
